import {} from '@chakra-ui/react';
import Active from './Active';
import Normal from './Normal';
import None from './None';
import Disable from './Disable';

import { DayObj, DayType } from '../type';

type DayProps = {
  onChangeDay: (date: Date) => void;
} & DayObj;

export default function Day({ onChangeDay, date, dayType, day }: DayProps) {
  switch (dayType) {
    case DayType.NONE:
      return <None />;
    case DayType.ACTIVE:
      return <Active day={day} />;
    case DayType.DISABLE:
      return <Disable day={day} />;
    case DayType.NORMAL:
      return <Normal day={day} onClick={() => onChangeDay(date)} />;
    default:
      return <None />;
  }
}
